/*
 * Copyright (c) Dito Technologies
 */

import React, {Dispatch} from "react";
import styles from "./UploadWorkspaceFileDeleteButton.module.scss";
import classnames from "classnames";
import {faMinus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Action, DeleteFileAction} from "ui/feature/root/FormReducer";

interface Props {
    className?: string;
    file: File;
    dispatch: Dispatch<Action>;
}

const UploadWorkspaceFileDeleteButton: React.FC<Props> = ({className, dispatch, file}) => {
    const deletePressed = React.useCallback(() => {
        const action: DeleteFileAction = {
            type: "delete_file",
            file: file
        }
        dispatch(action);
    }, [file, dispatch])
    return (
        <div className={classnames(styles.deleteButton, className)} onClick={deletePressed}>
            <FontAwesomeIcon size={"1x"} icon={faMinus}/>
        </div>
    )
}

export default UploadWorkspaceFileDeleteButton;
